/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/chat.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Chat',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.10812 11.3519V13.0812L6.96504 11.5506H9.38148C11.951 11.5506 14.034 9.46761 14.034 6.89807C14.034 4.32853 11.951 2.24551 9.38148 2.24551H6.61841C4.04887 2.24551 1.96584 4.32853 1.96584 6.89807C1.96584 8.70597 2.99679 10.275 4.50795 11.0458L5.10812 11.3519ZM0.865845 6.89807C0.865845 3.72102 3.44135 1.14551 6.61841 1.14551H9.38148C12.5585 1.14551 15.134 3.72102 15.134 6.89807C15.134 10.0751 12.5585 12.6506 9.38148 12.6506H7.35995L4.82614 14.7391C4.5 15.008 4.00812 14.776 4.00812 14.3533V12.0257C2.14305 11.0744 0.865845 9.13537 0.865845 6.89807Z"
            fill="currentColor"
          />
        </>
      )
    },
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.32562 2.39991L18.6744 2.3999C19.7171 2.40279 20.7148 2.82357 21.4498 3.56782C22.1845 4.31183 22.5972 5.31853 22.6 6.36752L22.6 14.5384C22.6 15.5892 22.1886 16.5987 21.4535 17.3451C20.7183 18.0917 19.719 18.5139 18.6744 18.5168L14.6583 18.5168L12.8357 21.3264C12.7249 21.4971 12.5353 21.6 12.3319 21.5999C12.1285 21.5998 11.939 21.4966 11.8285 21.3258L10.0058 18.5076H5.32728C4.29015 18.5064 3.27832 18.0769 2.5503 17.3397C1.81911 16.5993 1.40144 15.5787 1.40002 14.5384V6.36752C1.40285 5.31853 1.81556 4.31183 2.5503 3.56782C3.28528 2.82357 4.28293 2.40279 5.32562 2.39991ZM5.32816 3.5999C4.60773 3.6021 3.91588 3.89281 3.40413 4.41102C2.89213 4.92948 2.60221 5.63359 2.60002 6.36997V14.5375C2.60221 15.2739 2.89213 15.978 3.40413 16.4965C3.91583 17.0146 4.60761 17.3053 5.32797 17.3076H10.3323C10.5359 17.3076 10.7255 17.4108 10.8361 17.5817L12.333 19.8963L13.8289 17.5903C13.9396 17.4198 14.129 17.3168 14.3323 17.3168H18.6721C19.3937 17.3146 20.0866 17.0228 20.5986 16.503C21.111 15.9827 21.4 15.2764 21.4 14.5384L21.4 6.37075C21.3979 5.63434 21.1079 4.9295 20.5959 4.41102C20.0842 3.89281 19.3923 3.6021 18.6719 3.5999H5.32816Z"
            fill="currentColor"
          />
        </>
      )
    },
    '48': {
      viewBox: '0 0 49 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.75 25.3361V28.4716L15.2108 25.6006H18.6452C18.5765 26.0098 18.5316 26.4269 18.5117 26.8506H15.7857L13.2593 29.7982C12.6551 30.5031 11.5 30.0758 11.5 29.1474V26.1851C7.98538 24.7915 5.5 21.3613 5.5 17.3506C5.5 12.1039 9.7533 7.85063 15 7.85063H20C25.079 7.85063 29.2271 11.8363 29.4871 16.8506H29C28.7433 16.8506 28.4888 16.8598 28.2367 16.878C27.9917 12.5415 24.3977 9.10063 20 9.10063H15C10.4437 9.10063 6.75 12.7943 6.75 17.3506C6.75 20.8316 8.90636 23.812 11.9607 25.0231L12.75 25.3361ZM36.25 35.3361L37.0393 35.0231C40.0936 33.812 42.25 30.8316 42.25 27.3506C42.25 22.7943 38.5564 19.1006 34 19.1006H29C24.4436 19.1006 20.75 22.7943 20.75 27.3506C20.75 31.907 24.4437 35.6006 29 35.6006H33.7892L36.25 38.4716V35.3361ZM34 17.8506C39.2467 17.8506 43.5 22.1039 43.5 27.3506C43.5 31.3613 41.0146 34.7915 37.5 36.1851V39.1474C37.5 40.0758 36.3449 40.5031 35.7407 39.7982L33.2143 36.8506H29C23.7533 36.8506 19.5 32.5973 19.5 27.3506C19.5 22.1039 23.7533 17.8506 29 17.8506H34Z"
            fill="#767676"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
